module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-box-vc"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('div', {
    staticClass: "main-box-content"
  }, [_c('h3', {
    staticClass: "uppercase"
  }, [_vm._v("Audi Field Fanwalk")]), _vm._v(" "), _c('h4', [_vm._v("BLACK-AND-RED FOREVER")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger-inverse",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("GET STARTED")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b43cd87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = Xxih
// module chunks = 1